<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>报名信息</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span>报名筛选</span>
                </el-col>
            </el-row>
            <el-form
                :model="queryForm"
                class="filter_Form"
                label-width="80px"
                ref="queryFormRef"
            >
                <el-row :gutter="50">
                    <el-col :span="6">
                        <el-form-item label="所属赛区" prop="districtId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.districtId"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_district"
                                    :key="item.id"
                                    :label="item.districtName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="营地类型" prop="type">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.type"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_campType"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="姓名" prop="userName">
                            <el-input
                                v-model="queryForm.userName"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="手机号" prop="userPhone">
                            <el-input
                                v-model="queryForm.userPhone"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否缴费" prop="userName">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.payd"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="入营测试" prop="trial">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.trial"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="签署协议" prop="contract">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.contract"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row :gutter="20" type="flex" justify="end">
                <el-col :span="2">
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        style="width: 100%"
                        @click="getCampList"
                        >查询</el-button
                    >
                </el-col>
                <el-col :span="2">
                    <el-button
                        type="warning"
                        icon="el-icon-refresh-right"
                        size="small"
                        style="width: 100%"
                        @click="queryReset"
                        >重置</el-button
                    >
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col :span="12">
                    <span>成员列表</span>
                </el-col>
                <el-col :span="12">
                    <div style="text-align: right">
                        <el-button
                            type="primary"
                            size="small"
                            @click="campUserExport"
                            icon="el-icon-download"
                            >导出报名信息</el-button
                        >
                    </div>
                </el-col>
            </el-row>
            <el-table
                :data="campUserList"
                header-cell-class-name="tableHeaderStyle"
                border
                stripe
            >
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column
                    align="center"
                    label="赛区"
                    prop="districtName"
                    width="120px"
                ></el-table-column>
                <el-table-column label="营地名称" prop="campName">
                </el-table-column>
                <el-table-column
                    label="营地类型"
                    prop="campType"
                    :formatter="campTypeFormatter"
                ></el-table-column>
                <el-table-column label="选手信息" prop="userName" width="150px">
                    <template slot-scope="scope">
                        <div>
                            <span style="font-weight: 700;">姓名：{{ scope.row.userName }} {{ scope.row.sex === '1' ? '(男)' : '(女)' }}</span>
                            <br />
                            <span>手机号：<MaskedPhone :phone="scope.row.userPhone" /></span>
                            <br />
                            <span>年级：{{ scope.row.grade }}年级</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    label="省市区"
                    prop="areaName"
                ></el-table-column> -->
                <el-table-column
                    label="学校名称"
                    prop="schoolName"
                ></el-table-column>
                <!-- <el-table-column
                    label="年级"
                    prop="grade_name"
                ></el-table-column> -->
                <el-table-column label="是否缴费" prop="payd">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.payd === true"
                            size="mini"
                            >已缴费</el-tag
                        >
                        <el-tag type="danger" v-else size="mini">未缴费</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="缴费金额" prop="orderAmount">
                    <template slot-scope="scope">
                        <div style="color: red">
                            ￥{{ scope.row.orderAmount }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="是否入营测试" prop="trial">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.trial === true"
                            size="mini"
                            >已测试</el-tag
                        >
                        <el-tag type="danger" v-else size="mini">未测试</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否签合同(协议)" prop="contract">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.contract === true"
                            size="mini"
                            >已签署</el-tag
                        >
                        <el-tag type="danger" v-else size="mini">未签署</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="note"></el-table-column>
                <el-table-column label="操作" width="90px">
                    <template scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="small"
                            @click="editCampDetail(scope.row)"
                            >查看信息</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                v-if="campUserList.length !== 0"
            >
            </el-pagination>
        </el-card>
        <el-dialog
            title="报名信息"
            :visible.sync="addInfoDialog"
            width="50%"
            @close="handleCloseDialog"
        >
            <el-form
                :model="addInfoModel"
                label-width="100px"
                :disabled="true"
                ref="addInfoFormRef"
                :rules="addInfoRules"
                style="width: 100%"
            >
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="营员姓名" prop="userName">
                            <el-input
                                v-model="addInfoModel.userName"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="userPhone">
                            <el-input
                                v-model="addInfoModel.userPhone"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否入营测试" prop="trial">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.trial"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="测试时间" prop="trialTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.trialTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否缴费" prop="payd">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.payd"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缴费时间" prop="paydTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.paydTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否签署协议" prop="contract">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.contract"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签署时间" prop="contractTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.contractTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="订单号" prop="orderNo">
                            <el-input
                                v-model="addInfoModel.orderNo"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注" prop="note">
                            <el-input
                                v-model="addInfoModel.note"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="缴费凭证" prop="paymentVoucherUrl">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadImageResults.uploadUrl"
                                :show-file-list="false"
                                :on-success="uploadCoverImgSuccess"
                                :headers="uploadImageResults.headerObj"
                                :data="{
                                    filePath:
                                        'spbcnapp/camp/paymentVoucherImg/',
                                }"
                            >
                                <img
                                    v-if="addInfoModel.paymentVoucherUrl"
                                    class="img-cover"
                                    :src="addInfoModel.paymentVoucherUrl"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" @click="addCampersClick"
                    >确认</el-button
                > -->
                <el-button type="primary" @click="addInfoDialog = false"
                    >确认</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { campUserPage, campUserDel, campUserInsert, campUserEdit, queryDistrictPage } from '@/http/api'

export default {
  data () {
    return {
      uploadImageResults: {
        uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      dict_district: [],
      addInfoDialog: false,
      addInfoModel: {
        campId: this.$route.query.campId,
        userPhone: '',
        userName: '',
        trial: null,
        trialTime: '',
        payd: null,
        paydTime: '',
        orderNo: '',
        note: '',
        contractTime: '',
        contract: ''
      },
      addInfoRules: {
        userName: [{ required: true, message: '请输入', trigger: 'blur' }],
        userPhone: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      boolData: this.$userInfo.dict_boolData(),
      dict_campType: this.$userInfo.getDataList(this, 't_camp_type').then(value => { this.dict_campType = value }),
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        userName: '',
        userPhone: ''
      },
      total: 0,
      campUserList: []
    }
  },
  created () {
    this.getDistrictList()
    this.getCampList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getCampList () {
      console.log('queryForm', this.queryForm)
      campUserPage(this.queryForm).then((res) => {
        this.campUserList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getCampList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getCampList()
    },
    queryReset () {
      this.$refs.queryFormRef.resetFields()
      this.getCampList()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 营员点击事件
    addCampersClick () {
      if (this.addInfoModel.id) {
        campUserEdit(this.addInfoModel).then((res) => {
          this.$message.success('保存成功')
          this.$refs.addInfoFormRef.resetFields()
          this.addInfoDialog = false
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      } else {
        campUserInsert(this.addInfoModel).then((res) => {
          this.$message.success('添加成功')
          this.$refs.addInfoFormRef.resetFields()
          this.addInfoDialog = false
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      }
    },
    // 编辑成员信息
    editCampDetail (rowData) {
      this.addInfoModel = JSON.parse(JSON.stringify(rowData))
      this.addInfoDialog = true
    },
    uploadCoverImgSuccess (res) {
      console.log('res', res)
      this.$set(this.addInfoModel, 'paymentVoucherUrl', res.data)
    },
    // 导出营员
    campUserExport () {
      var downLoadUrl = this.$http.defaults.baseURL + 'campUser/export'
      var formData = JSON.parse(JSON.stringify(this.queryForm))
      formData.pageSize = 1000
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', formData)
    },
    handleCloseDialog () {
    },
    showDeleteCampTip (id) {
      this.$confirm('此操作将删除该营地成员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        campUserDel(id).then((res) => {
          this.$message.success('删除成功')
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => { })
    },
    campTypeFormatter (row, column, cellValue) {
      var temp = '未知'
      for (let index = 0; index < this.dict_campType.length; index++) {
        const element = this.dict_campType[index]
        if (element.dictValue === (cellValue + '')) {
          return element.dictLabel
        }
      }
      return temp
    }
  }
}
</script>

<style lang="less" scoped>
.button-right {
    margin-left: 20px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}
.img-cover {
    width: 120px;
    display: block;
}
</style>
